module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-MediumItalic-WebS-97362acfd9f4d1ca6cadc79d2d2debfa.woff2";